import Config from '@config';
import { initializeMeteringNodeTypeApi } from '@gasbi/shared/common/features/meteringNodeType';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const meteringNodeType = initializeMeteringNodeTypeApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const { meteringNodeTypeApi, useGetMeteringNodeTypeQuery } =
  meteringNodeType;
